import {
  forwardRef,
  useEffect,
  useId,
  useImperativeHandle,
  useState,
} from 'react'

import Action from 'ageas-react-component-action'
import NavBar from 'ageas-react-component-nav-bar'
import ProgressBarItem from 'ageas-react-component-progressbaritem'

import { Container, TabContainer } from './styles'

type Props = {
  initialTab?: number
  tabs: (string | JSX.Element)[]
  disabledTabs?: number[]
  pages: JSX.Element[]
  showButtons?: boolean
  buttonLabel?: string
  onChange?: (currentTab: number) => void
}

export type HandleActionProp = {
  handleNextStep: () => void
}

export const Tab = forwardRef<HandleActionProp, Props>(
  (
    {
      initialTab = 0,
      tabs,
      pages,
      disabledTabs,
      showButtons,
      buttonLabel,
      onChange,
    },
    ref,
  ) => {
    const id = useId()
    const [tabActive, setTabActive] = useState(`tab-${initialTab}`)

    const currentTab = Number(tabActive.split('tab-')[1] || 0)

    const handleNextStep = () => {
      setTabActive(`tab-${currentTab + 1}`)
    }

    useImperativeHandle(ref, () => ({
      handleNextStep,
    }))

    useEffect(() => {
      onChange && onChange(currentTab)
    }, [currentTab, onChange])

    return (
      <Container>
        <TabContainer>
          {tabs?.map((tab, index) => (
            <ProgressBarItem
              key={index}
              id={`tab-${index}`}
              version="1"
              name={`tab-${index}`}
              active={`tab-${index}` === tabActive || 'tab-0'}
              onValueChanged={(value: string) => {
                if (!(disabledTabs || []).includes(index)) {
                  setTabActive(value)
                }
              }}
              lastItemIndex={tabs.length}
              label={tab}
              disabled={(disabledTabs || []).includes(index)}
              lastItem={index === tabs.length - 1}
              componentNavBar={true}
            />
          ))}
        </TabContainer>
        {pages && (
          <NavBar
            id={`${id}NavigationTabTab`}
            key={currentTab}
            colorTheme={'blue'}
            table={{
              rows: pages.map((page) => ({
                columns: [
                  {
                    componentCol: [page],
                  },
                ],
              })),
            }}
            activeTab={currentTab}
            buttonNext={false}
            buttonLabel="{t('general.nextAction')}"
            hasMaxWidth={true}
          />
        )}
        {showButtons && currentTab < tabs.length - 1 && (
          <Action
            id={`${id}buttonTab`}
            label={buttonLabel || ''}
            type="button"
            onValueChanged={handleNextStep}
          />
        )}
      </Container>
    )
  },
)
